export default "__VITE_ASSET__CGquSk13__"